import { render, staticRenderFns } from "./GroupListItem.vue?vue&type=template&id=097e73bc&scoped=true&"
import script from "./GroupListItem.vue?vue&type=script&lang=js&"
export * from "./GroupListItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupListItem.vue?vue&type=style&index=0&id=097e73bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e73bc",
  null
  
)

export default component.exports